<template>
<div class="layer-project" data-project-name="hos-hk"><!-- Project Name -->
    <div class="layer-project-detail">
        <section class="project-visual">
            <div>
                <h1 class="project-tit">
                    <div><span class="nowrap">HMC Online</span></div>
                    <div><span class="nowrap">Direct Sale <br>Platform</span></div>
                    <div><span class="nowrap">(India/</span><br><span class="nowrap">Hongkong)</span></div>
                </h1>
                <div class="link">
                    <div><a href="http://www.hyundai.com/in" target="_blank">www.hyundai.com/in</a></div>
                    <div><a href="http://www.hyundai.com/hk" target="_blank">www.hyundai.com/hk</a></div>
                </div>
            </div>
        </section>
        <!-- Details [s] -->
        <section class="project-overview">
            <div class="inner-section">
                <h2 class="project-overview-tit">Overview</h2>
                <p class="project-overview-txt">글로벌 가이드를 적용한 국가별 사이트를 통해 통일된 현대자동차의 아이덴티티 확립과 온라인 구매 플랫폼이라는 새로운 마켓을 구축하는 프로젝트 입니다.</p>
                <div class="project-overview-diagram">
                    <p class="diagram01">Global Design Guide <br>Responsive Website</p>
                    <p class="diagram02">
                        <ul>
                            <li>Global Corporate Identity</li>
                            <li>Online Sales <br>Platform <br>UI/UX Design</li>
                            <li>User <br>Convenience</li>
                        </ul>
                    </p>
                    <p class="diagram03">Hyundai Motor <br>Company <br>Master Platform</p>
                </div>
            </div>
        </section>
        <section class="section full india">
            <div class="inner-section">
                <strong class="project-subtit align-c">India</strong>
                <div class="india-swiper">
                    <div class="swiper-container">
                        <ul class="swiper-wrapper">
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-01@m.jpg"></li>
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-02@m.jpg"></li>
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-03@m.jpg"></li>
                        </ul>
                    </div>
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </section>
        <section class="section full india-ctb01">
            <div class="inner-section">
                <div class="pc-wrap">
                    <div class="pc"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-ctb01-01@m.jpg" ></div>
                </div>
                <div class="mobile-wrap">
                    <div class="swiper-container">
                        <ul class="swiper-wrapper">
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-ctb01-02-01.png" ></li>
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-ctb01-02-02.png" ></li>
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-ctb01-02-03.png" ></li>
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-ctb01-02-04.png" ></li>
                        </ul>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section full hong-kong">
            <div class="inner-section">
                <strong class="project-subtit align-c">Hong Kong</strong>
                <div class="contents-section pc">
                    <div class="img-wrap">
                        <div class="img"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-hk-pc-01@m.png"></div>
                    </div>
                </div>
                <div class="contents-section tablet">
                    <div class="img-wrap">
                        <div class="img"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-hk-tablet-01@m.png"></div>
                    </div>
                </div>
                <div class="contents-section mobile">
                    <div class="img-wrap">
                        <div class="img"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-hk-mobile-01@m.png"></div>
                    </div>
                </div>
                <div class="contents-section my-garage">
                    <div class="swiper-container">
                        <ul class="swiper-wrapper">
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-my-garage-01.png"></li>
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-my-garage-02.png"></li>
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-my-garage-03.png"></li>
                            <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-my-garage-04.png"></li>
                        </ul>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section full hong-kong-ctb01">
            <div class="inner-section">
                <div class="pc-wrap">
                    <div class="pc"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-hong-kong-ctb01-01@m.png"></div>
                </div>
                <div class="mobile-wrap">
                    <div class="mobile"><img src="" alt="" data-src="/static/img/project-detail/hos-hk/hos-hk-india-img-hong-kong-ctb01-02@m.png"></div>
                </div>
            </div>
        </section>
        <section class="section style">
            <div class="inner-section">
                <div class="point-font-area">
                    <div class="img">
                        <img src="" alt="" data-src="/static/img/project-detail/hos-hk/point-font01@m.png">
                    </div>
                    <div class="img">
                        <img src="" alt="" data-src="/static/img/project-detail/hos-hk/point-font02@m.png">
                    </div>
                </div>
                <div class="point-color-area">
                    <ul>
                        <li class="item01"><div>#00aad2</div></li>
                        <li class="item02"><div>#002c5f</div></li>
                        <li class="item03"><div>#6e5e3c</div></li>
                        <li class="item04"><div>#666666</div></li>
                        <li class="item05"><div>#cba111</div></li>
                        <li class="item06"><div>#e63312</div></li>
                    </ul>
                </div>
                <div class="point-icon-area">
                    <div class="img">
                        <img src="" alt="" data-src="/static/img/project-detail/hos-hk/point-icon@m.png">
                    </div>
                </div>
            </div>
        </section>
        <!-- Details [e] -->
        <section class="project-client"><strong class="a11y-hidden">Hyundai</strong></section>
    </div>

    
    <app-pjmove></app-pjmove>
</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var indiaSwiper = new Swiper(".india-swiper .swiper-container", {
			slidesPerView: "auto",
			spaceBetween: 0,
			loop: true,
			navigation: {
				nextEl: ".india-swiper .swiper-button-next",
				prevEl: ".india-swiper .swiper-button-prev",
			},
			pagination: {
				el: ".india-swiper .swiper-pagination",
				clickable: true,
			},
			breakpoints: {
				// when window width is <= 712px
				711: {
					// centeredSlides: true,
				},
				1279: {
					// spaceBetween: 13
				},
			},
		});

		var isHongkongSwiper = false;
		var hongkongSwiper;
		var isIndiaMobileSwiper = false;
		var indiaMobileSwiper;
		hongkongSwiperSet();
		indiaMobileSwiperSet();

		$(window).on("resize", function () {
			//console.log(isHongkongSwiper, isIndiaMobileSwiper);
			var w = $(window).outerWidth();
			if (w >= 712 && isHongkongSwiper) {
				hongkongSwiper.destroy();
				isHongkongSwiper = false;
			}

			if (w >= 712 && indiaMobileSwiper) {
				indiaMobileSwiper.destroy();
				isIndiaMobileSwiper = false;
			}

			if (w < 712) {
				hongkongSwiperSet();
				indiaMobileSwiperSet();
			}
		});

		function hongkongSwiperSet() {
			var w = $(window).outerWidth();

			if (isHongkongSwiper | (w >= 712)) {
				return;
			}

			isHongkongSwiper = true;
			hongkongSwiper = new Swiper(".hong-kong .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 20,
				centeredSlides: true,
				pagination: {
					el: ".hong-kong .swiper-pagination",
					clickable: true,
				},
			});
		}

		function indiaMobileSwiperSet() {
			var w = $(window).outerWidth();

			if (isIndiaMobileSwiper | (w >= 712)) {
				return;
			}

			isIndiaMobileSwiper = true;
			indiaMobileSwiper = new Swiper(".india-ctb01 .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 20,
				centeredSlides: true,
				pagination: {
					el: ".india-ctb01 .swiper-pagination",
					clickable: true,
				},
			});
		}
	},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* temp */
.project-tit .nowrap {
	display: inline-block;
}
.project-client {
	background: url(/static/img/project-detail/hos-hk/ci.png) 50% / auto 27.5px
		no-repeat;
}

@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
}

@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hos-hk/bg-overview@m.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
	.project-tit .block {
		display: block;
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hos-hk/bg-overview@t.jpg);
	}
	.project-tit br {
		display: none;
	}
	.project-tit .block {
		display: block;
	}
	.project-client {
		background-size: auto 71px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hos-hk/bg-overview@w.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
}

/* overview [s] */
/* project-overview */
.project-overview {
	background-color: #131c31;
}
.project-overview .project-overview-tit,
.project-overview .project-overview-txt {
	color: #fff;
}
.project-overview .project-overview-txt br {
	display: none;
}
.project-overview .project-overview-diagram {
	margin-top: 42px;
	color: #fff;
}
.project-overview .project-overview-diagram .diagram01 {
	padding-bottom: 52px;
	text-align: center;
}
.project-overview .project-overview-diagram .diagram02 ul {
	position: relative;
	width: 269px;
	height: 252px;
	margin: 0 auto;
}
.project-overview .project-overview-diagram .diagram02 ul::before {
	content: "";
	position: absolute;
	top: -30px;
	left: 50%;
	width: 15px;
	height: 15px;
	margin: -7px 0 0 -7px;
	border: 1px solid #fff;
	border-width: 0 0 1px 1px;
	transform: rotate(-45deg);
}
.project-overview .project-overview-diagram .diagram02 ul li {
	display: flex;
	position: absolute;
	width: 138px;
	height: 138px;
	border: 1px solid #fff;
	border-radius: 50%;
	text-align: center;
	justify-content: center;
	align-items: center;
}
.project-overview .project-overview-diagram .diagram02 ul li:nth-child(1) {
	top: 0;
	left: 0;
}
.project-overview .project-overview-diagram .diagram02 ul li:nth-child(2) {
	top: 0;
	right: 0;
}
.project-overview .project-overview-diagram .diagram02 ul li:nth-child(3) {
	top: 113px;
	left: 65px;
}
.project-overview .project-overview-diagram .diagram03 {
	position: relative;
	padding-top: 68px;
	text-align: center;
}
.project-overview .project-overview-diagram .diagram03::before {
	content: "";
	position: absolute;
	top: 20px;
	left: 50%;
	width: 1px;
	height: 30px;
	margin-left: -1px;
	background-color: #fff;
}
.project-overview .project-overview-diagram .diagram03 span {
	display: block;
	margin-top: 6px;
	font-size: 1.3rem;
}

@media screen and (min-width: 712px) {
	.project-overview .project-overview-diagram {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 40px 0;
	}
	.project-overview .project-overview-diagram .diagram01 {
		padding: 0 35px 0 0;
	}
	.project-overview .project-overview-diagram .diagram02 ul {
		width: 331px;
		height: auto;
	}
	.project-overview .project-overview-diagram .diagram02 ul::before {
		top: 50%;
		left: -26px;
		width: 20px;
		height: 20px;
		margin-top: -10px;
		transform: rotate(-135deg);
	}
	.project-overview .project-overview-diagram .diagram02 ul::after {
		content: "";
		display: block;
		clear: both;
	}
	.project-overview .project-overview-diagram .diagram02 ul li {
		position: relative;
		top: auto;
		right: auto;
		left: auto;
		float: left;
		width: 115px;
		height: 115px;
	}
	.project-overview .project-overview-diagram .diagram02 ul li:nth-child(3) {
		top: auto;
		left: auto;
	}
	.project-overview .project-overview-diagram .diagram02 ul li + li {
		margin-left: -7px;
	}
	.project-overview .project-overview-diagram .diagram03 {
		padding: 0 0 0 40px;
	}
	.project-overview .project-overview-diagram .diagram03::before {
		top: 50%;
		left: 9px;
		width: 30px;
		height: 1px;
		margin-top: -1px;
	}
}

@media screen and (min-width: 1280px) {
	.project-overview .project-overview-diagram {
		margin: 50px 0 20px;
	}
	.project-overview .project-overview-diagram .diagram01 {
		padding-right: 116px;
		font-size: 20px;
	}
	.project-overview .project-overview-diagram .diagram02 ul {
		width: 662px;
	}
	.project-overview .project-overview-diagram .diagram02 ul::before {
		left: -86px;
		width: 40px;
		height: 40px;
		margin-top: -19px;
		border-width: 0 0 2px 2px;
	}
	.project-overview .project-overview-diagram .diagram02 ul li {
		width: 230px;
		height: 230px;
		font-size: 20px;
		border-width: 2px;
	}
	.project-overview .project-overview-diagram .diagram02 ul li + li {
		margin-left: -14px;
	}
	.project-overview .project-overview-diagram .diagram03 {
		padding-left: 146px;
		font-size: 20px;
	}
	.project-overview .project-overview-diagram .diagram03::before {
		left: 40px;
		width: 80px;
		height: 2px;
	}
	.project-overview .project-overview-diagram .diagram03 span {
		font-size: 18px;
	}
}
/* overview [e] */

/* india [s] */
.section.india .project-tit {
	font-weight: 500;
}
.section.india .india-swiper {
	overflow: visible;
	width: 100%;
}
.section.india .swiper-slide {
	padding: 20px;
}
.section.india .swiper-slide img {
	border-radius: 15px;
	box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.35);
}
.section.india .swiper-pagination {
	position: static;
	height: 13px;
}
.section.india .swiper-button-prev,
.section.india .swiper-button-next {
	display: none;
}

@media screen and (min-width: 712px) {
	.section.india .inner-section {
		padding: 0 40px;
	}
	.section.india .india-swiper {
		position: relative;
		padding: 0 52px;
	}
	.section.india .swiper-container {
		border: 10px solid #000;
		border-radius: 10px;
	}
	.section.india .swiper-slide {
		padding: 0;
	}
	.section.india .swiper-pagination {
		display: none;
	}
	.section.india .swiper-slide img {
		width: 100%;
		box-shadow: none;
	}
	.section.india .swiper-button-prev,
	.section.india .swiper-button-next {
		display: block;
		width: 40px;
		height: 40px;
		margin-top: -20px;
	}
	.section.india .swiper-button-prev {
		left: 0;
		background-image: url(/static/img/project-detail/hos-hk/arrow-prev.png);
		background-size: 40px;
	}
	.section.india .swiper-button-next {
		right: 0;
		background-image: url(/static/img/project-detail/hos-hk/arrow-next.png);
		background-size: 40px;
	}
}
@media screen and (min-width: 1280px) {
	.section.india {
		padding-top: 105px;
		padding-bottom: 120px;
	}
	.section.india .inner-section {
		max-width: 1240px;
		margin: 0 auto;
	}
	.section.india .india-swiper {
		position: relative;
		padding: 0 114px;
	}
	.section.india .swiper-container {
		border-width: 20px;
		border-radius: 20px;
	}
	.section.india .swiper-button-prev,
	.section.india .swiper-button-next {
		width: 80px;
		height: 80px;
		margin-top: -40px;
		background-size: auto;
	}
	.section.india .swiper-button-prev {
		left: -40px;
	}
	.section.india .swiper-button-next {
		right: -40px;
	}
}
/* india [e] */

/* india ctb01 [s] */
.section.india-ctb01 {
	padding-top: 0;
	padding-bottom: 0;
}
.section.india-ctb01 img {
	width: 100%;
}
.section.india-ctb01 .mobile-wrap {
	position: relative;
	padding-bottom: 40px;
	background-color: #e4e6ec;
}
.section.india-ctb01 .mobile-wrap .swiper-container {
	overflow: visible;
	padding-top: 40px;
	padding-bottom: 33px;
}
.section.india-ctb01 .mobile-wrap .swiper-slide {
	width: 43.75%;
}
.section.india-ctb01 .mobile-wrap .swiper-slide img {
	width: 100%;
	box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.22);
	border-radius: 20px;
}
.section.india-ctb01 .mobile-wrap .swiper-pagination {
	left: 0;
	width: 100%;
	height: 13px;
}

@media screen and (min-width: 712px) {
	.section.india-ctb01 {
		position: relative;
	}
	.section.india-ctb01 .pc-wrap {
		height: 860px;
	}
	.section.india-ctb01 .pc-wrap .pc {
		position: absolute;
		left: 50%;
		width: 1424px;
		max-width: 1424px;
		margin-left: -712px;
	}
	.section.india-ctb01 .pc-wrap .pc img {
		max-width: 100%;
	}
	.section.india-ctb01 .mobile-wrap {
		padding: 50px 0;
	}
	.section.india-ctb01 .mobile-wrap .swiper-container {
		margin-left: 5.61%;
		padding: 0;
	}
	.section.india-ctb01 .mobile-wrap .swiper-slide {
		width: 21.4%;
		margin-right: 2.87%;
	}
	.section.india-ctb01 .mobile-wrap .swiper-slide img {
		box-shadow: 12px 11px 20px 0px rgba(0, 0, 0, 0.22);
	}
	.section.india-ctb01 .mobile-wrap .swiper-pagination {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.section.india-ctb01 .pc-wrap .pc {
		position: absolute;
		left: 50%;
		width: 1920px;
		max-width: 1920px;
		margin-left: -960px;
	}
	.section.india-ctb01 .mobile-wrap {
		padding: 160px 0;
	}
	.section.india-ctb01 .mobile-wrap .swiper-container {
		width: 1280px;
		margin: 0 auto;
	}
	.section.india-ctb01 .mobile-wrap .swiper-slide {
		width: 290px;
		margin-right: 40px;
	}
}
/* india ctb01 [e] */

/* hong kong [s] */
.hong-kong .project-subtit {
	font-weight: 500;
}
.hong-kong img {
	width: 100%;
}
.hong-kong .img {
	position: relative;
}
.hong-kong .pc .img {
	width: 98.75%;
}
.hong-kong .tablet {
	position: relative;
	margin-top: 42px;
}
.hong-kong .tablet::before {
	content: "";
	position: absolute;
	top: 89%;
	left: -50%;
	width: 250%;
	height: 107%;
	background-color: #2c2f33;
	transform: rotate(-30deg);
	transform-origin: left;
}
.hong-kong .mobile {
	margin-top: -59px;
}
.hong-kong .swiper-container {
	overflow: visible;
	padding-bottom: 33px;
}
.hong-kong .swiper-slide {
	width: 43.75%;
}
.hong-kong .swiper-slide img {
	width: 100%;
	box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.22);
	border-radius: 20px;
}
.hong-kong .swiper-pagination {
	width: 100%;
	height: 13px;
}
@media screen and (min-width: 712px) {
	.hong-kong .pc .img {
		width: 96.76%;
	}
	.hong-kong .tablet {
		margin-top: 60px;
	}
	.hong-kong .tablet::before {
		top: 138%;
		height: 76%;
	}
	.hong-kong .tablet .img {
		width: 84.97%;
		margin: 0 auto;
	}
	.hong-kong .mobile {
		margin-top: -75px;
	}

	.hong-kong .swiper-container {
		overflow: visible;
		margin-left: 5.61%;
		padding-bottom: 20px;
	}
	.hong-kong .swiper-slide {
		width: 21.4%;
		margin-right: 2.87%;
	}
	.hong-kong .swiper-slide img {
		width: 100%;
		box-shadow: 12px 11px 20px 0px rgba(0, 0, 0, 0.22);
	}
	.hong-kong .swiper-pagination {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.hong-kong .swiper-container {
		width: 1280px;
		margin: 40px auto 0;
		padding-bottom: 140px;
	}
	.hong-kong .swiper-slide {
		width: 290px;
		margin-right: 40px;
	}
	.hong-kong .swiper-slide img {
		width: 290px;
	}
}
/* hong kong [e] */

/* hong-kong-ctb01 [s] */
.section.hong-kong-ctb01 {
	padding-top: 0;
}
.hong-kong-ctb01 .pc-wrap {
	position: relative;
}
.hong-kong-ctb01 .pc-wrap::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 37.7%;
	background-color: #2c2f33;
}
.hong-kong-ctb01 .pc-wrap .pc {
	position: relative;
	width: 97.65%;
	margin: 0 auto;
	padding-top: 35px;
}
.hong-kong-ctb01 .pc-wrap .pc img {
	width: 100%;
}
.hong-kong-ctb01 .mobile-wrap {
	margin-top: 20px;
}
.hong-kong-ctb01 .mobile-wrap .mobile img {
	width: 100%;
}
@media screen and (min-width: 712px) {
	.hong-kong-ctb01 .pc-wrap::before {
		height: 37.3%;
	}
	.hong-kong-ctb01 .pc-wrap .pc {
		width: 91.15%;
	}
	.hong-kong-ctb01 .mobile-wrap {
		margin-top: 50px;
	}
}
@media screen and (min-width: 1280px) {
	.hong-kong-ctb01 .pc-wrap::before {
		height: 39.4%;
	}
	.hong-kong-ctb01 .pc-wrap .pc {
		position: relative;
		left: 50%;
		width: 1314px;
		margin-left: -657px;
		padding-top: 115px;
	}
	.hong-kong-ctb01 .pc-wrap .pc img {
		width: auto;
	}
	.hong-kong-ctb01 .mobile-wrap {
		margin-top: 60px;
	}
	.hong-kong-ctb01 .mobile-wrap .mobile {
		position: relative;
		left: 50%;
		width: 1892px;
		margin-left: -946px;
	}
}
/* hong-kong-ctb01 [e] */

/* style [s] */
.style {
	padding: 100px 15px 50px;
	background-color: #002c5f;
}
.style .point-font-area .img {
	width: 290px;
}
.style .point-font-area .img + .img {
	margin-top: 24px;
}
.style .point-color-area {
	max-width: 290px;
	margin: 30px auto 0;
}
.style .point-color-area ul {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
}
.style .point-color-area ul li {
	margin-top: 15px;
	margin-left: 16px;
}
.style .point-color-area ul li > div {
	position: relative;
	width: 86px;
	height: 86px;
	padding: 34px 5px;
	text-align: center;
	font-size: 1.4rem;
	color: #fff;
	line-height: 18px;
}
.style .point-color-area ul li:nth-child(1),
.style .point-color-area ul li:nth-child(4) {
	margin-left: 0;
}
/* .style .point-color-area ul li:nth-child(3) > div{color:#000;} */
.style .point-color-area .item01 > div {
	background-color: #00aad2;
}
.style .point-color-area .item02 > div {
	background-color: #001e40;
}
.style .point-color-area .item03 > div {
	background-color: #6e5e3c;
}
.style .point-color-area .item04 > div {
	background-color: #666666;
}
.style .point-color-area .item05 > div {
	background-color: #cba111;
}
.style .point-color-area .item06 > div {
	background-color: #e63312;
}
.style .point-color-area ul li span {
	display: block;
}
.style .point-icon-area {
	max-width: 290px;
	margin: 30px auto 0;
}

@media screen and (min-width: 712px) {
	.style {
		padding-bottom: 80px;
	}
	.style .inner-section {
		padding: 0 28px;
	}
	.style .point-font-area {
		display: flex;
	}
	.style .point-font-area .img {
		flex: 1;
		text-align: center;
	}
	.style .point-font-area .img:nth-child(1) img {
		width: 264px;
	}
	.style .point-font-area .img:nth-child(2) img {
		width: 246px;
	}
	.style .point-font-area .img + .img {
		margin: 0 0 0 60px;
	}
	.style .point-color-area {
		display: flex;
		max-width: 1080px;
		justify-content: center;
	}
	.style .point-color-area ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		margin: 0 -25px;
	}
	.style .point-color-area ul li {
		margin: 0;
		padding: 10px 25px;
	}
	.style .point-color-area ul li:nth-child(1),
	.style .point-color-area ul li:nth-child(4) {
		margin: 0;
	}
	.style .point-icon-area {
		max-width: 1080px;
	}
}

@media screen and (min-width: 1280px) {
	.style {
		padding-top: 160px;
		padding-bottom: 160px;
	}
	.style .point-icon-area {
		margin: 50px auto 0;
	}
	.style .point-font-area .img:nth-child(1) {
		padding-left: 36px;
	}
	.style .point-font-area .img:nth-child(1) img,
	.style .point-font-area .img:nth-child(2) img {
		width: auto;
	}
	.style .point-color-area {
		margin-top: 50px;
	}
	.style .point-color-area ul li {
		padding: 10px 0;
	}
	.style .point-color-area ul li + li {
		margin-left: 90px;
	}
	.style .point-color-area ul li:nth-child(4),
	.style .point-color-area ul li:nth-child(5),
	.style .point-color-area ul li:nth-child(6) {
		margin-left: 88px;
	}
	.style .point-color-area ul li > div {
		width: 106px;
		height: 106px;
		line-height: 34px;
	}
}
/* style [e] */
</style>


// WEBPACK FOOTER //
// src/projects/hos-hk.vue